import { Lock } from "lucide-react";
import { fmtRating } from "@/lib/api";

export const LOCKED_TIP = "Verrouillé · Débloque la zone 2 pour voir qui c'est";

// Bubble above a tapped pin / dot. Anchor clamped so it stays inside the map.
export default function MapBubble({ tip, onLocked }) {
  const x = Math.min(80, Math.max(20, tip.x));
  const lift = tip.kind === "dot" ? 16 : tip.small ? 30 : 42;
  return (
    <div
      data-testid="map-bubble"
      onClick={(e) => e.stopPropagation()}
      className="fade-up absolute z-[6] w-max max-w-[220px] rounded-card border border-line bg-surface px-3 py-2 text-left shadow-modal"
      style={{ left: `${x}%`, top: `${tip.y}%`, transform: `translate(-50%, calc(-100% - ${lift}px))` }}
    >
      {tip.kind === "dot" ? (
        <>
          <p className="flex items-center gap-1.5 text-[13px] font-medium text-ink" data-testid="map-bubble-locked">
            <Lock className="h-3.5 w-3.5 shrink-0" strokeWidth={1.75} />
            {LOCKED_TIP}
          </p>
          <button
            type="button"
            data-testid="map-bubble-unlock"
            onClick={onLocked}
            className="mt-2 h-9 w-full rounded-full bg-ink px-3 text-[13px] font-semibold text-bg transition-opacity duration-150 hover:opacity-90"
          >
            Débloquer la zone 2
          </button>
        </>
      ) : (
        <>
          <p className="line-clamp-2 break-words text-[14px] font-medium leading-snug text-ink" data-testid="map-bubble-name">
            {tip.card?.name}
          </p>
          <p className="mt-0.5 text-[12px] text-muted">
            Note <span className="num text-ink">{fmtRating(tip.card?.rating)}</span> · <span className="num text-ink">{tip.card?.reviews ?? 0}</span> avis
          </p>
        </>
      )}
    </div>
  );
}
